import { Button } from "ui/components/button";
import { Label } from "ui/components/label";
import useTableFilters from "@/hooks/useTableFilters";
import UserCombobox from "components/directus/combobox/user";
import CalendarDatePicker from "ui/components/comp-507";
import { formatDateForAPI } from "utils/utils";
import SelectAny from "components/select/select-any";
import { Checkbox } from "ui/components/checkbox";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "ui/components/select";

export default function OpeningInterviewsFilters({
    filters,
    setFilters,
    setIsOpen,
    isOpen,
    clearFilters,
    defaultFilters,
}) {
    const {
        localFilters,
        applyFilters,
        clearLocalFilters,
        handleSetLocalFilters,
        setLocalFilters,
    } = useTableFilters({
        filters,
        setFilters,
        setIsOpen,
        clearFilters,
        initialFilters: {
            applicant: undefined,
            status: undefined,
            date_scheduled: undefined,
            is_cleared: undefined,
            ...defaultFilters,
        },
    });

    const clearedOptions = [
        { label: "All", value: "all" },
        { label: "Cleared", value: "true" },
        { label: "Not Cleared", value: "false" },
    ];

    return (
        <div className="w-full px-4 space-y-4">

            {/* applicant */}
            <div>
                <Label className="mb-2 text-sm">Applicant</Label>
                <UserCombobox
                    value={localFilters.applicant?.employee?._eq}
                    onChange={(selectedItem) =>
                        setLocalFilters({
                            ...localFilters,
                            applicant: {
                                ...localFilters.applicant,
                                employee: {
                                    _eq: selectedItem,
                                },
                            },
                        })
                    }
                    dependenton={isOpen}
                />
            </div>

            {/* Status Filter */}
            <div>
                <Label className="mb-2 text-sm">Status</Label>
                <SelectAny
                    collection="opening_interviews"
                    field="status"
                    value={localFilters?.status?._eq}
                    onChange={(selectedItem) => {
                        setLocalFilters({
                            ...localFilters,
                            status: { _eq: selectedItem },
                        });
                    }}
                />
            </div>

            {/* Date */}
            <div>
                <Label className="mb-2 text-sm">Scheduled Date</Label>
                <CalendarDatePicker
                    stack={true}
                    disabled={false}
                    date={{
                        from: localFilters?.date_scheduled?._gte,
                        to: localFilters?.date_scheduled?._lte,
                    }}
                    setDate={(range) => {
                        setLocalFilters({
                            ...localFilters,
                            date_scheduled: {
                                _gte: range?.from ? formatDateForAPI(range.from) : undefined,
                                _lte: range?.to ? formatDateForAPI(range.to) : undefined,
                            },
                        });
                    }}
                    className="w-full"
                />
            </div>

            {/* cleared */}
            <div>
                <Label className="mb-2 text-sm">Cleared</Label>
                <Select
                    onValueChange={(val) => {
                        let isCleared = undefined;
                        if (val === "true") isCleared = true;
                        if (val === "false") isCleared = false;
                        setLocalFilters({
                            ...localFilters,
                            is_cleared: isCleared !== undefined ? { _eq: isCleared } : undefined,
                        });
                    }}
                    value={
                        localFilters?.is_cleared?._eq === true 
                            ? "true" 
                            : localFilters?.is_cleared?._eq === false 
                                ? "false" 
                                : "all"
                    }
                >
                    <SelectTrigger className="w-full">
                        <SelectValue placeholder="Select" />
                    </SelectTrigger>
                    <SelectContent>
                        {clearedOptions.map((opt) => (
                            <SelectItem key={opt.value} value={opt.value}>
                                {opt.label}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>

            {/* Action Buttons */}
            <div className="flex place-self-end gap-4">
                <Button variant="outline" onClick={clearLocalFilters}>
                    Clear
                </Button>
                <Button onClick={() => applyFilters()}>Apply</Button>
            </div>
        </div>
    );
}
